import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as models from '../../../models'

/** Displays the actions configured for one entity-collection table row. */
@ngCore.Component({
  imports: [],
  selector: 'icons-renderer',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component<
  TTypeParams extends
    ec.models.TypeParams.Constraint = ec.models.TypeParams.Constraint,
> {
  /** TODO:  */
  public readonly rowConfigSg = ngCore.input.required<
    models.config.Row.Applied<TTypeParams>
  >({
    alias: 'rowConfig',
  })

  /** TODO:  */
  public readonly iconConfigsSg = ngCore.computed(
    (rowConfig = this.rowConfigSg()) => rowConfig.iconsConfigs ?? [],
  )
}
